/* mbi-a11y.js — MBI accessibility behaviour (2026-10-04). Loaded deferred by
   snippets/mbi-css-assets.liquid (core group). Kept separate from custom.js. */
/* =============================================================================
   MBI a11y 2026-10-04 (Lighthouse "aria-hidden-focus"):
   Align's <drawer-component id="mini-cart"> ships aria-hidden="true" and never
   updates it, so when closed its links/buttons are still keyboard-focusable,
   and when open it is hidden from screen readers. Keep aria-hidden + inert in
   sync with the drawer's .open class. Core component-cart-drawer.js untouched.
   - Instance open() is wrapped so inert is lifted BEFORE Align moves focus in.
   - MutationObserver covers every other path (close button, overlay, Escape,
     Boost CJS fallback that adds .open directly).
   ========================================================================== */
(function () {
  function sync(drawer, isOpen) {
    if (isOpen) {
      drawer.removeAttribute('aria-hidden');
      drawer.inert = false;
    } else {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
    }
  }
  function init() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    if (!drawer.dataset.mbiA11ySync) {
      drawer.dataset.mbiA11ySync = '1';
      sync(drawer, drawer.classList.contains('open'));
      new MutationObserver(function () {
        sync(drawer, drawer.classList.contains('open'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    // open() only exists once the custom element has upgraded; wrap it once.
    if (typeof drawer.open === 'function' && !drawer.open.mbiWrapped) {
      var originalOpen = drawer.open;
      drawer.open = function () {
        sync(drawer, true);
        return originalOpen.apply(this, arguments);
      };
      drawer.open.mbiWrapped = true;
    }
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('drawer-component').then(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
